import React from "react";

const Live = ({ style = {}, size = "36", className = "", fill = "#73788B", viewBox = "0 0 36 36" }) => (
    <svg
        width={size}
        style={style}
        height={size}
        viewBox={viewBox}
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        className={`${className || ""}`}
        xmlnsXlink="http://www.w3.org/1999/xlink"
    >
        <g fill={fill} className="u_fill" clipPath="url(#a)">
            <path d="M19.5 18.5a1.5 1.5 0 0 1-3 0v-.014a1.5 1.5 0 0 1 3 0v.014ZM25.499 18.486c0 1.988-.79 3.896-2.196 5.303a1.5 1.5 0 0 1-2.121-2.122 4.5 4.5 0 0 0 0-6.363 1.5 1.5 0 0 1 2.12-2.12 7.5 7.5 0 0 1 2.197 5.302Z" />
            <path d="M31.5 18.485a13.503 13.503 0 0 1-3.954 9.546 1.5 1.5 0 0 1-2.12-2.12 10.5 10.5 0 0 0 0-14.85 1.5 1.5 0 1 1 2.12-2.122 13.5 13.5 0 0 1 3.954 9.546ZM10.502 18.486c0 1.988.79 3.896 2.196 5.303a1.5 1.5 0 0 0 2.12-2.122 4.5 4.5 0 0 1 0-6.363 1.5 1.5 0 0 0-2.12-2.12 7.5 7.5 0 0 0-2.197 5.302Z" />
            <path d="M4.5 18.485a13.503 13.503 0 0 0 3.954 9.546 1.5 1.5 0 0 0 2.121-2.12 10.5 10.5 0 0 1 0-14.85 1.5 1.5 0 1 0-2.12-2.122A13.501 13.501 0 0 0 4.5 18.485Z" />
        </g>
        <defs>
            <clipPath id="a">
                <path fill="#fff" d="M0 0h36v36H0z" />
            </clipPath>
        </defs>
    </svg>
);

export default Live;